import { ArticleDatabaseCatalog } from '../articles/article_database_catalog.js?v=20260831f';

function isFallbackBomArticleNo(articleNo = '') {
  const value = String(articleNo || '').trim().toLowerCase();
  if (!value) return true;
  if (value.startsWith('!')) return true;
  return /^(?:-|n\/?a|none|null|undefined|tbd|todo|unknown|unbekannt|fallback|placeholder|platzhalter|dummy|temp)$/i.test(value)
    || /(?:^|[-_.\s])(?:unknown|unbekannt|fallback|placeholder|platzhalter|dummy|temp)(?:$|[-_.\s])/i.test(value);
}

function isBomUnknownArticle(row = {}) {
  const articleNo = ArticleDatabaseCatalog.getArticleNo(row);
  if (isFallbackBomArticleNo(articleNo)) return true;
  return !ArticleDatabaseCatalog.resolveArticle(articleNo);
}

export {
  isFallbackBomArticleNo,
  isBomUnknownArticle
};
